import React from 'react';
import { Card } from './ui/Card';
import { Monitor, TrendingUp, Check } from 'lucide-react';
export function UniqueValue() {
  return <section className="py-20 bg-[#0A0E27] relative overflow-hidden" data-id="element-300" data-mp="3gtbagqyju6ic">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#141B3A]/50 to-transparent -z-10" data-id="element-301" data-mp="3bw1bokp9sihu"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-302" data-mp="37sd3q0wq7kw2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-303" data-mp="8ej3ud9hzbhf">
          <div data-id="element-304" data-mp="3h14nela8amm">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-305" data-mp="3h9f6ztxn3un">
              IT + Vertrieb ={' '}
              <span className="text-[#FF5722]" data-id="element-306" data-mp="3vhxn2kwskk5v">Dein Vorteil</span>
            </h2>
            <p className="text-lg text-[#94A3B8] mb-8 leading-relaxed" data-id="element-307" data-mp="3qjw5y5ixeux1">
              Die meisten CRM-Berater sind entweder reine Techniker, die den
              Vertrieb nicht verstehen, oder Vertriebler ohne technisches
              Tiefenwissen. Ich vereine beides.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-308" data-mp="18iofhlo51kez">
              <div className="flex items-start gap-4" data-id="element-309" data-mp="1dgg7sgsp38jp">
                <div className="w-12 h-12 rounded-lg bg-blue-500/10 flex items-center justify-center flex-shrink-0" data-id="element-310" data-mp="1dfwzzswre0je">
                  <Monitor className="w-6 h-6 text-blue-500" data-id="element-311" data-mp="zj1gf6ivsqp3" />
                </div>
                <div data-id="element-312" data-mp="14e6yfu95xl7w">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-313" data-mp="14huoukjb9rie">
                    IT & Entwicklung
                  </h3>
                  <ul className="space-y-2 text-[#94A3B8]" data-id="element-314" data-mp="uidkq7jpjloj">
                    <li className="flex items-center gap-2" data-id="element-315" data-mp="ujor8f4jf7jc">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-316" data-mp="grqnkjtli3uk" />
                      Programmierung (PHP, JS, Python)
                    </li>
                    <li className="flex items-center gap-2" data-id="element-317" data-mp="kpohfzyb9e4a">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-318" data-mp="6srq7xea5umv" />
                      Komplexe Webanwendungen
                    </li>
                    <li className="flex items-center gap-2" data-id="element-319" data-mp="bt70uh76go15">
                      <Check className="w-4 h-4 text-blue-500" data-id="element-320" data-mp="2di359hwqjeun" />
                      Professionelle IT-Architektur
                    </li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-321" data-mp="24oq27n4yiwuu">
                <div className="w-12 h-12 rounded-lg bg-[#FF5722]/10 flex items-center justify-center flex-shrink-0" data-id="element-322" data-mp="1zpn991294h38">
                  <TrendingUp className="w-6 h-6 text-[#FF5722]" data-id="element-323" data-mp="2wecr4rdvp9p7" />
                </div>
                <div data-id="element-324" data-mp="2sdj3lz4clwwu">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-325" data-mp="2sf3wzlexf9t4">
                    Vertrieb & Praxis
                  </h3>
                  <ul className="space-y-2 text-[#94A3B8]" data-id="element-326" data-mp="2ngsobe0db5ch">
                    <li className="flex items-center gap-2" data-id="element-327" data-mp="2iejvqireq5aw">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-328" data-mp="1bz9fn640qa6j" />3 Jahre aktive
                      Vertriebserfahrung
                    </li>
                    <li className="flex items-center gap-2" data-id="element-329" data-mp="16zohuz0l47ve">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-330" data-mp="wx19to9gfh16" />
                      B2B und B2C Expertise
                    </li>
                    <li className="flex items-center gap-2" data-id="element-331" data-mp="11wdxgb85gs4t">
                      <Check className="w-4 h-4 text-[#FF5722]" data-id="element-332" data-mp="16uytrzka6rnz" />
                      Eigenes Vertriebsteam aufgebaut
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="relative" data-id="element-333" data-mp="1fm7n2vrhbgfl">
            <Card className="p-8 border-[#334155] bg-[#141B3A]/80 backdrop-blur-sm" data-id="element-334" data-mp="1fpd73wl93s4g">
              <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-335" data-mp="1ko6nbwrx9x8b">
                Das Ergebnis
              </h3>
              <div className="space-y-4" data-id="element-336" data-mp="1ujzybbpztinz">
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-337" data-mp="1uiyo19gsx07b">
                  <span className="text-[#94A3B8]" data-id="element-338" data-mp="3ree7jdsnfbjq">Technisch robust</span>
                  <span className="text-green-500 font-bold" data-id="element-339" data-mp="71p6vg14s28">100%</span>
                </div>
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-340" data-mp="1qmb38i204gx9">
                  <span className="text-[#94A3B8]" data-id="element-341" data-mp="1lnrgiffl313u">Praktisch nutzbar</span>
                  <span className="text-green-500 font-bold" data-id="element-342" data-mp="1zmzh9creaha5">100%</span>
                </div>
                <div className="p-4 rounded-lg bg-[#0A0E27] border border-[#1E293B] flex items-center justify-between" data-id="element-343" data-mp="1uopgmmmwioh5">
                  <span className="text-[#94A3B8]" data-id="element-344" data-mp="16zwjwnyggclh">Akzeptanz im Team</span>
                  <span className="text-green-500 font-bold" data-id="element-345" data-mp="12ykt4f3uhlbp">Hoch</span>
                </div>
              </div>
              <div className="mt-8 text-center" data-id="element-346" data-mp="1gq7wt0049w4i">
                <p className="text-white font-medium mb-2" data-id="element-347" data-mp="1byg7essp5wfy">
                  "Keine Theorie – nur Praxis."
                </p>
                <p className="text-sm text-[#94A3B8]" data-id="element-348" data-mp="o8dkss7jxioq">
                  Jede Funktion wurde in der Praxis getestet und optimiert.
                </p>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}